const FILEPOND = {
    onReady() {
        FILEPOND.build();
    },
    build() {
        const elements = document.querySelectorAll('.filepond:not(.assigned)');
        FilePond.registerPlugin(
            FilePondPluginFileEncode,
            FilePondPluginFileValidateSize,
            FilePondPluginFileValidateType
        );
        elements.forEach(element => {
            element.classList.add('assigned');
            FilePond.create(element, {
                labelIdle: element.dataset.uploadLabelIdle,
                labelInvalidField: element.dataset.uploadLabelInvalidField,
                labelFileWaitingForSize: element.dataset.uploadLabelFileWaitingForSize,
                labelFileSizeNotAvailable: element.dataset.uploadLabelFileSizeNotAvailable,
                labelFileLoading: element.dataset.uploadLabelFileLoading,
                labelFileLoadError: element.dataset.uploadLabelFileLoadError,
                labelFileProcessingComplete: element.dataset.uploadLabelFileProcessingComplete,
                labelFileProcessingAborted: element.dataset.uploadLabelFileProcessingAborted,
                labelFileProcessingError: element.dataset.uploadLabelFileProcessingError,
                labelTapToCancel: element.dataset.uploadLabelTapToCancel,
                labelTapToRetry: element.dataset.uploadLabelTapToRetry,
                labelTapToUndo: element.dataset.uploadLabelTapToUndo,
                labelButtonRemoveItem: element.dataset.uploadLabelButtonRemoveItem,
                labelButtonAbortItemLoad: element.dataset.uploadLabelButtonAbortItemLoad,
                labelButtonRetryItemLoad: element.dataset.uploadLabelButtonRetryItemLoad,
                labelButtonAbortItemProcessing: element.dataset.uploadLabelButtonAbortItemProcessing,
                labelButtonUndoItemProcessing: element.dataset.uploadLabelButtonUndoItemProcessing,
                labelButtonRetryItemProcessing: element.dataset.uploadLabelButtonRetryItemProcessing,
                labelMaxFileSizeExceeded: element.dataset.uploadLabelMaxFileSizeExceeded,
                labelMaxFileSize: element.dataset.uploadLabelMaxFileSize,
                labelMaxTotalFileSizeExceeded: element.dataset.uploadLabelMaxTotalFileSizeExceeded,
                labelMaxTotalFileSize: element.dataset.uploadLabelMaxTotalFileSize,
                allowMultiple: true,
                allowFileEncode: true,
                maxFiles: 10,
                required: false,
                maxParallelUploads: 1,
                instantUpload: false,
                acceptedFileTypes: ['image/*', 'application/pdf']
            });
        });
    }
}